__turbopack_context__.v({
  "activeFilter": "_5PqanG_activeFilter",
  "activeView": "_5PqanG_activeView",
  "card": "_5PqanG_card",
  "cardActions": "_5PqanG_cardActions",
  "cardBody": "_5PqanG_cardBody",
  "categoryTag": "_5PqanG_categoryTag",
  "clearSearch": "_5PqanG_clearSearch",
  "closeDialog": "_5PqanG_closeDialog",
  "codeFooter": "_5PqanG_codeFooter",
  "codeHeading": "_5PqanG_codeHeading",
  "codePanel": "_5PqanG_codePanel",
  "codeTitle": "_5PqanG_codeTitle",
  "copyModel": "_5PqanG_copyModel",
  "copySnippet": "_5PqanG_copySnippet",
  "detailHint": "_5PqanG_detailHint",
  "detailNavigation": "_5PqanG_detailNavigation",
  "detailRow": "_5PqanG_detailRow",
  "dialog": "_5PqanG_dialog",
  "dialogContent": "_5PqanG_dialogContent",
  "dialogFooter": "_5PqanG_dialogFooter",
  "dialogHeader": "_5PqanG_dialogHeader",
  "download": "_5PqanG_download",
  "emptyState": "_5PqanG_emptyState",
  "explorer": "_5PqanG_explorer",
  "eyebrow": "_5PqanG_eyebrow",
  "favoriteButton": "_5PqanG_favoriteButton",
  "feedback": "_5PqanG_feedback",
  "filters": "_5PqanG_filters",
  "grid": "_5PqanG_grid",
  "hashLine": "_5PqanG_hashLine",
  "intro": "_5PqanG_intro",
  "languageSwitch": "_5PqanG_languageSwitch",
  "largePreview": "_5PqanG_largePreview",
  "list": "_5PqanG_list",
  "modelDetails": "_5PqanG_modelDetails",
  "modelName": "_5PqanG_modelName",
  "noPreview": "_5PqanG_noPreview",
  "pagination": "_5PqanG_pagination",
  "previewButton": "_5PqanG_previewButton",
  "reset": "_5PqanG_reset",
  "resultRange": "_5PqanG_resultRange",
  "resultsHeading": "_5PqanG_resultsHeading",
  "searchBox": "_5PqanG_searchBox",
  "shortcut": "_5PqanG_shortcut",
  "sortLabel": "_5PqanG_sortLabel",
  "source": "_5PqanG_source",
  "srOnly": "_5PqanG_srOnly",
  "toolbar": "_5PqanG_toolbar",
  "viewSwitcher": "_5PqanG_viewSwitcher",
});
